import { useState, useEffect } from "react";
import React from "react";
import {
  machineProfile,
  part,
  vendor,
  customer,
  partCategory,
  purchaseOrder,
  inventory,
} from "../../api";
import { toast } from "react-toastify";
import {
  dateFormat,
  getEmptyField,
  getFileUrl,
  printLocation,
  renderImage,
} from "../../utils/helper";
import { QRCode } from "react-qrcode-logo";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import LoadingIndicator from "../../components/LoadingIndicator";
import NormalInput from "../../components/form/HorizontalNormalInput";
import NormalSelect from "../../components/form/HorizontalNormalSelect";
import NormalTextArea from "../../components/form/HorizontalNormalTextarea";
import { DatepickerOpt } from "../../components/form/DatepickerOpt";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Card, CardBody, CardHeader } from "../../components/card/card";
import { MachineElement } from "../../components/MachineElement";
import ImageViewer from "../../components/ImageViewer";
import ConfirmationDlg from "../../components/ConfirmationDlg";
import { format } from "date-fns";
import { PurchaseOrderItem } from "../../components/PurchaseOrderItem";
import { Modal } from "react-bootstrap";
import { FulfillPurchaseOrder } from "../../components/FulfillPurchaseOrder";
import { PermissionChecker } from "../../components/PermissionChecker";

function DetailPurchaseOrder() {
  const { id } = useParams();
  const { config } = useAuth();
  const editMode = !!id;
  const { locations } = useDashboardContext();
  const [sublocations, setSublocations] = useState([]);
  const [selectedFile, setSelectedFile] = useState("");
  const [vendorList, setVendor] = useState([]);
  const [customerList, setCustomer] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [inventories, setInventories] = useState([]);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [preview, setPreview] = useState();
  const [locationValue, setLocationValue] = useState([]);
  const { getLocationName } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [action, setAction] = useState("");

  const [openPDF, setOpenPDF] = useState(false);
  const [openFulfill, setOpenFulfill] = useState(false);
  const [email, setEmail] = useState("");
  const [fulFillData, setFulfillData] = useState([]);

  const [billingAddressType, setBillingAddressType] = useState("custom");
  const [shippingAddressType, setShippingAddressType] = useState("custom");

  const [dataToSend, setDataToSend] = useState({
    name: "",
    number: "",
    vendor_id: "",
    description: "",
    billing_address: {},
    shipping_address: {},
    due_date: format(new Date(), "yyyy-MM-dd"),
    purchase_date: format(new Date(), "yyyy-MM-dd"),
    tax: 0,
    tax_type: "currency",
    shipping_cost: 0,
    other_cost: 0,
    items: [],
  });

  const navigate = useNavigate();

  const [emptyField, setEmptyField] = useState([]);

  function backToList() {
    navigate(-1);
  }

  useEffect(() => {
    getRecord();
  }, []);

  async function getRecord() {
    setIsLoading(true);
    const result = await purchaseOrder.getOne(id);

    if (result.ok) {
      const body = await result.json();
      let data = body.data;

      const defaultValue = {
        name: data.name,
        number: data.number,
        vendor_id: data.vendor_id || "",
        description: data.description,
        billing_address: data.billing_address,
        shipping_address: data.shipping_address,
        due_date: format(new Date(data.due_date), "yyyy-MM-dd"),
        purchase_date: format(new Date(data.purchase_date), "yyyy-MM-dd"),
        tax: data.tax,
        tax_type: data.tax_type,
        shipping_cost: data.shipping_cost,
        other_cost: data.other_cost,
        items: data.items,
        vendor: data.vendor,
        created_by: data.created_by,
        status: data.status,
        file:data.file
      };

      setDataToSend(defaultValue);
    }

    setIsLoading(false);
  }

  const getTotal = () => {
    const subtotal = dataToSend.items.reduce((prev, cur) => {
      return prev + cur.cost * cur.quantity;
    }, 0);
    if (dataToSend.tax_type == "currency") {
      return (
        subtotal +
        Number(dataToSend.tax) +
        Number(dataToSend.shipping_cost) +
        Number(dataToSend.other_cost)
      );
    }

    return (
      subtotal +
      Number((subtotal * dataToSend.tax) / 100) +
      Number(dataToSend.shipping_cost) +
      Number(dataToSend.other_cost)
    );
  };

  const handleOpenConfirmation = (action) => {
    setAction(action);
    setOpenConfirmation(true);
  };
  const handleCloseConfirmation = () => {
    setOpenConfirmation(false);
  };

  const handleSubmitAction = async () => {
    setIsLoading(true);
    const result = await purchaseOrder.updateStatus(id, { status: action });
    if (result.ok) {
      setDataToSend((prev) => {
        return {
          ...prev,
          status: action,
        };
      });
      handleCloseConfirmation();
    }

    setIsLoading(false);
  };

  const handleSendPdf = async () => {
    try {
      setIsLoading(true);
      const result = await purchaseOrder.sendPdf(id, { email: email });
      if (result.ok) {
        setOpenPDF(false);
        setEmail("");
        toast.success("PDF File has been sent to the email");
      }
    } catch (e) {
      console.log(e);
      toast.error("Something went wrong, please try again");
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeFulfill = (value, i) => {
    const copy = [...fulFillData];
    copy[i] = value.payload;

    setFulfillData(copy);
  };

  const handleSubmitFulfill = async () => {
   
    let isOut = false

    fulFillData.forEach((obj, index) => {
      if (obj) {
        const id = Object.keys(obj)[0];
        const qty = Object.values(obj)[0];
        const inv = dataToSend.items[index];
  
        if (inv.quantity < qty) {
          isOut = true
        }

      }

    });

    if (isOut) {
      toast.error("Invalid value, there is out limit data");
      return;
    }

    try {
      setIsLoading(true);

      const res = await inventory.fulfill({
        purchaseOrderId: id,
        items: fulFillData,
      });
      if (res.ok) {
        toast.success("Succesfully fulfill the items");
        setOpenFulfill(false);
        getRecord();
      }
    } catch (er) {
      toast.error("Something wrong happened");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card>
      <LoadingIndicator open={isLoading} />
      <CardHeader>{editMode && "Edit "}Purchase Order Information</CardHeader>

      <CardBody>
        <div className="row justify-content-end gap-2">
          {dataToSend.status == "approved" && (
            <div
              onClick={() => setOpenFulfill(true)}
              className="btn btn-theme col-2"
            >
              Fulfill Item
            </div>
          )}
          <div
            onClick={() => setOpenPDF(true)}
            className="btn btn-primary col-2"
          >
            Generate PDF
          </div>
          <div
            style={{ pointerEvents: "none", textTransform: "uppercase" }}
            className={`btn btn-outline-${
              dataToSend.status == "new"
                ? "default"
                : dataToSend.status == "approved"
                ? "theme"
                : dataToSend.status == "fulfilled"
                ? "warning"
                : "danger"
            } w-25 me-2 `}
          >
            {dataToSend.status == "new"
              ? "Waiting for approval"
              : dataToSend.status}
          </div>
        </div>

        <ConfirmationDlg
          onSubmit={handleSendPdf}
          title={"Email Purchase Order"}
          type="submit"
          open={openPDF}
          onClose={() => setOpenPDF(false)}
        >
          <NormalInput
            onchange={(e) => setEmail(e.target.value)}
            value={email}
            label={"Recipient"}
            helperText={"Please add email"}
          />
        </ConfirmationDlg>

        <ConfirmationDlg
          btnSubmitText={"Fulfill"}
          onSubmit={handleSubmitFulfill}
          title={"Fulfill Purchase Order"}
          type="submit"
          open={openFulfill}
          onClose={() => setOpenFulfill(false)}
        >
          <p>Each item's quantity will be increased by the amount received</p>
          <div>
            {dataToSend.items.map((item, i) => {
              return (
                <FulfillPurchaseOrder
                  onChange={(value) => handleChangeFulfill(value, i)}
                  item={item}
                  key={i}
                />
              );
            })}
          </div>
        </ConfirmationDlg>
        <div className="row">
          <div className="col-12">
            <div>
              <NormalInput
                value={dataToSend["name"]}
                label="Title"
                readOnly
                name="name"
                emptyField={emptyField}
              />
              <NormalInput
                value={"PO#" + dataToSend["number"]}
                label="PO Number"
                readOnly
                name="number"
                emptyField={emptyField}
              />

              <NormalInput
                label={"Due Date"}
                type="date"
                readOnly
                value={dataToSend["due_date"]}
                name={"due_date"}
                emptyField={emptyField}
                className="form-control"
                required
              />

              <NormalTextArea
                value={dataToSend["description"]}
                label="Description"
                readOnly
                name="description"
                emptyField={emptyField}
              />
            </div>
          </div>
        </div>

        <div className="mb-4">
          <PurchaseOrderItem
            readOnly
            onChange={(v) => {}}
            value={dataToSend["items"]}
          />
        </div>

        <Card className={"mb-4"}>
          <CardBody>
            <div>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "separate",
                  borderSpacing: ".5em 1em",
                }}
              >
                <tbody>
                  <tr>
                    <td>Subtotal</td>
                    <td>:</td>
                    <td>
                      {config?.currency_symbol}{" "}
                      {dataToSend.items.reduce((prev, cur) => {
                        return prev + cur.cost * cur.quantity;
                      }, 0)}
                    </td>
                  </tr>
                  <tr>
                    <td>Taxes</td>
                    <td>
                      <select
                        name="tax_type"
                        value={dataToSend.tax_type}
                        className="form-control"
                      >
                        <option value="currency">
                          {config?.currency_symbol}
                        </option>
                        <option value="percentage">%</option>
                      </select>
                    </td>
                    <td>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <div class="input-group-text">
                            {dataToSend.tax_type == "currency"
                              ? config.currency_symbol
                              : "%"}
                          </div>
                        </div>
                        <input
                          readOnly
                          name="tax"
                          className="form-control"
                          value={dataToSend.tax}
                          type="number"
                        />
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>Shipping</td>
                    <td></td>
                    <td>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <div class="input-group-text">
                            {config?.currency_symbol}
                          </div>
                        </div>
                        <input
                          readOnly
                          className="form-control"
                          name="shipping_cost"
                          type="number"
                          value={dataToSend.shipping_cost}
                        />
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>Other Costs</td>
                    <td>:</td>
                    <td>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <div class="input-group-text">
                            {config?.currency_symbol}
                          </div>
                        </div>
                        <input
                          className="form-control"
                          type="number"
                          name="other_cost"
                          readOnly
                          value={dataToSend.other_cost}
                        />
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <b>Total</b>
                    </td>
                    <td>:</td>
                    <td>
                      {config?.currency_symbol} {getTotal()}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CardBody>
        </Card>

         <Card className="mb-4">
                          <CardHeader>Photo / File</CardHeader>
                          <CardBody>
                            <div class="form-group">
                            {!dataToSend.file && (
                                <p className="mt-2">
                                 - No File Uploaded - 
                                </p>
                              )}
                
                              {dataToSend.file && (
                                <p className="mt-2">
                                
                                  <a href={getFileUrl(dataToSend.file)} target="_blank">
                                    Here
                                  </a>{" "}
                                </p>
                              )}
                            </div>
                          </CardBody>
                        </Card>

        {["billing_address", "shipping_address"].map((item) => (
          <Card key={item} className="mb-4">
            <CardHeader>
              <div style={{ textTransform: "capitalize" }}>
                {item.replace("_", " ")}
              </div>
            </CardHeader>
            <CardBody>
              {item == "shipping_address" && (
                <NormalInput
                  label={"Ship To Name"}
                  readOnly
                  value={dataToSend[item]["ship_to_name"]}
                  name={`${item}.ship_to_name`}
                  className="form-control"
                />
              )}

              <NormalInput
                label={"Company Name"}
                readOnly
                value={dataToSend[item]["company_name"]}
                name={`${item}.company_name`}
                className="form-control"
              />

              <NormalInput
                label={"Address"}
                readOnly
                value={dataToSend[item]["address"]}
                name={`${item}.address`}
                className="form-control"
              />

              <NormalInput
                label={"Phone Number"}
                readOnly
                value={dataToSend[item]["phone_number"]}
                name={`${item}.phone_number`}
                className="form-control"
              />
            </CardBody>
          </Card>
        ))}

        {/* <Card className="mb-4">
          <LoadingIndicator open={isLoading} />
          <CardHeader>Vendor Information</CardHeader>
          <CardBody>
            <NormalInput
              label={"Name"}
              readOnly
              value={dataToSend.vendor?.vendor_name}
              className="form-control"
            />

            <NormalInput
              label={"Email"}
              readOnly
              value={dataToSend.vendor?.contact_email}
              className="form-control"
            />

            <NormalInput
              label={"Phone"}
              readOnly
              value={dataToSend.vendor?.contact_phone}
              className="form-control"
            />

            <NormalInput
              label={"Address"}
              readOnly
              value={dataToSend.vendor?.address}
              className="form-control"
            />
          </CardBody>
        </Card> */}

        <Card>
          <LoadingIndicator open={isLoading} />
          <CardHeader>More Information</CardHeader>
          <CardBody>
            <NormalInput
              label={"Requested by"}
              value={dataToSend.created_by?.firstname}
              readOnly
              emptyField={emptyField}
              className="form-control"
            />

            <NormalInput
              label={"Purchase Date"}
              type="date"
              readOnly
              value={dataToSend["purchase_date"]}
              name={"purchase_date"}
              emptyField={emptyField}
              className="form-control"
            />
          </CardBody>
        </Card>

        <div className="mt-4 flex">
          {dataToSend.status == "new" && (
            <>
              <PermissionChecker permissions={["approve purchase order"]} hideIfNotAllowed>
                <button
                onClick={() => handleOpenConfirmation("approved")}
                className="btn btn-outline-theme btn-lg me-2"
              >
                APPROVE
              </button>
              </PermissionChecker>

              <PermissionChecker permissions={["decline purchase order"]} hideIfNotAllowed>
                <button
                className="btn btn-outline-warning btn-lg me-2"
                onClick={() => handleOpenConfirmation("declined")}
              >
                DECLINE
                </button>
              </PermissionChecker>
            </>
          )}

          <button
            className="btn btn-outline-danger btn-lg"
            onClick={backToList}
          >
            CANCEL
          </button>
        </div>

        <ConfirmationDlg
          title={"Purchase Order Action"}
          open={openConfirmation}
          onClose={handleCloseConfirmation}
          onSubmit={handleSubmitAction}
        >
          <p style={{ pb: 2 }}>
            Are you sure you want to {action} this purchase order ?
          </p>
        </ConfirmationDlg>
      </CardBody>
    </Card>
  );
}

export default DetailPurchaseOrder;
